<template>
   

    <div class="horse-sec">
        <Carousel class="horse-slider-sec"  :breakpoints="breakpoints">
            <Slide class="owl-carousel owl-theme" v-for="slide in 10" :key="slide">
                <div class="item">
                    <router-link :to="{ name: 'racing-carousel', params: { type: type }}">
                        <div class="horse-con">
                            <div class="live-heading text-center">
                                <h4 class="team-list-wet">11.55 AM</h4>
                                <span class="text-dark">Port Macquarie (AU)</span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </Slide>

            <template #addons>
                <Navigation />
            </template>

        </Carousel>
    </div>
</template>
<script>

import { Carousel, Slide, Navigation } from 'vue3-carousel';

export default {
    name: "Race",
    components: {
        Carousel,
        Slide,
        Navigation
    },
    data: () => ({
        // carousel settings
        // settings: {
        //     itemsToShow: 1,
        //     snapAlign: 'center',
        // },
        // breakpoints are mobile first
        // any settings not specified will fallback to the carousel settings
        breakpoints: {
            // 700px and up
            0: {
                itemsToShow: 2.5,
                snapAlign: 'center',
            },
            // 1024 and up
            600: {
                itemsToShow: 3.5,
                snapAlign: 'start',
            },
            768: {
                itemsToShow: 4,
                snapAlign: 'start',
            },
            1000: {
                itemsToShow: 4,
                snapAlign: 'start',
            },
        },
    }),
    props:['type']
};
</script>